import { OwlMascot } from "../components/OwlMascot";

/**
 * "What is Owl" — a simple, plain-English explainer. Kept deliberately short.
 * NYVO is a SEBI-registered RIA; Owl is its daily market voice + a chat about
 * fund ratings. Honest about what it is and isn't.
 */
export function AboutOwl() {
  return (
    <section id="about" className="mt-14">
      <div className="card flex flex-col gap-6 p-6 sm:flex-row sm:items-start sm:gap-8 sm:p-8">
        <div className="shrink-0">
          <OwlMascot size="hero" />
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-nyvo-900 sm:text-2xl">
            What is Owl?
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
            Owl is your morning market read. Every day it pulls out the few
            things actually worth knowing, from India and around the world,
            and tells them straight, in plain English, with a bit of wit. No
            jargon, no hype, no "to the moon."
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
            Tap any card to ask Owl about it, or just{" "}
            <a href="#chat" className="font-semibold text-sky-700 hover:underline">
              chat with Owl
            </a>{" "}
            about a fund or a rating. Owl is built by NYVO, a SEBI-registered
            investment adviser, so the views are honest, but they're general
            market commentary, not a tip on what you personally should buy.
          </p>
          <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-slate-500">
            <span>📩 Every morning</span>
            <span>🦉 Plain English</span>
            <span>📊 Backed by real data</span>
            <span>🚫 Never a tip</span>
          </div>
        </div>
      </div>
    </section>
  );
}
